"use client"

import { useAuth } from "@clerk/nextjs"
import { useEffect } from "react"
import { setClerkTokenGetter } from "@/utils/axiosInstance"

export function AxiosAuthProvider({ children }: { children: React.ReactNode }) {
  const { getToken } = useAuth()

  useEffect(() => {
    // Set up the token getter for axios
    setClerkTokenGetter(async () => {
      try {
        // Force a fresh JWT on every authenticated request. Clerk's default
        // JWT lifetime is 60 minutes, and a stale/expired token surfaces as
        // confusing 401/422s mid-form on long-idle pages. The extra network
        // round-trip per request is a worthwhile correctness trade-off.
        return await getToken({ skipCache: true })
      } catch (error) {
        console.error("Failed to get Clerk token for axios:", error)
        return null
      }
    })
  }, [getToken])

  return <>{children}</>
}
